<template>
    <div class="bet_card" :style="{ background: props.topBackground }">
        <div class="top_content" >
            <img :src="props.cardImage" alt="">
            <div class="content_text">
                <div style="padding: 5px;">{{ props.content }}</div>
                <div class="text2" v-if="infoValue"><span>{{ props.infoValue }}</span>/10K</div>
            </div>
        </div>

        <div class="bottom_content" :style="{ background: props.downBackground }">
            <div class="bottom_text">
                <div class="text1">{{ $t('agent.validBets') }}</div>
                <span>{{ props.bottomText }}</span>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { defineProps } from 'vue';
const props = defineProps({
    content: {
        type: String,
        default: () => ''
    },
    infoValue: {
        type: String,
        default: () => ''
    },
    bottomText: {
        type: String,
        default: () => ''
    },
    topBackground: {
        type: String,
        default: () => '#ccc'
    },
    downBackground: {
        type: String,
        default: () => '#000'
    },
    cardImage:{
        type: String,
        default: () => '#000'
    },
})
</script>

<style scoped>
.bet_card {
    position: relative;
    border-radius: 10px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    overflow: hidden;
    height: 100%;
}

.top_content {
    padding: 5px;
    width: 100%;
}

.bet_card img {
    width: 80%;
    padding-top: 10px;
}

.content_text {
    color: #f8b2dd;
    padding: 10px 0 0;
}

.bottom_text {
    padding: 8px 0;
    font-size: 11.5px;
}

.text1 {
    margin: 5px 0;
}

.bottom_text span {
    font-size: 15px;
    color: #f8e400;
}

.bottom_content {
    color: #ffa200;
    font-weight: 700;
    width: 100%;
    height: 30%;
}

.text2 {
    padding-top: 2px;
}

.text2 span {
    color: #FFEE00;
}
</style>